<template>
	<div style="width: 1000px;margin: 70px auto;">
		<bar></bar>
		<div style="width: 1000px;height: 30px; margin-top: 70px;;border-bottom: 1px solid #000000;"><span style="font-size: 14px;float: left">首页/账户管理</span></div>
		<div style="text-align: left;padding-top: 40px;font-size:20px;">我的账户</div>
		<div class="information">个人信息</div>
		<div class="address">送货地址</div>
		<div style="float: left;margin: 0 auto;">
			<div style="margin: 25px auto;text-align: left;">
				<span style="font-size: 14px;">
					登录Email：
					<span style="font-size: 13px;">{{ form.loginName }}</span>
				</span>
				<a href="javascript:;" style="padding-left: 45px;font-size: 13px;" @click="password">修改密码</a>
			</div>
			<div style="text-align: left">
				<span style="font-size: 14px;">
					用户姓名：
					<span style="font-size: 13px;">{{ form.staffName }}</span>
				</span>
			</div>
			<div style="text-align: left;margin: 25px auto;">
				<span style="font-size: 14px;">
					联系电话：
					<input type="text" style="width: 250px;" v-model="form.phone" />
				</span>
			</div>
		</div>

		<div style="float: right;width: 528px;text-align: left;">
			<div style="margin: 25px 0;">
				<div style="font-size: 14px;">
					当前送货地址：
					<span style="font-size: 13px;">{{ form.deliveryAddress }}</span>
				</div>
			</div>
		</div>
		<div style="float: right;width: 528px;text-align: left;">
			<div style="margin: 10px auto;">
				<el-radio v-model="form.deliveryType" label="0">上海办公室</el-radio>
			</div>
			<div style="margin: 10px auto;">
				<el-radio v-model="form.deliveryType" label="1">北京办公室</el-radio>
			</div>
			<div style="margin: 10px auto;">
				<el-radio v-model="form.deliveryType" label="2">
					非上海/北京办公室
					<input v-model="inputAddress" type="text" style="width: 300px;" />
				</el-radio>
			</div>
		</div>
		<div style="position: relative;width: 400px;">
			<div style="position: absolute;bottom:-400px;left:380px;"><el-button :plain="true" @click="open" id="change-button">保存</el-button></div>
		</div>
	</div>
</template>

<script>
import bar from '@/components/bar.vue';
import { accountInfo, saveAccount } from '../api/service'
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
	data() {
		return {
			form: {
				id: '',
				deliveryType: '',
				deliveryAddress: '',
				loginName: '',
				phone: '',
				staffName: ''
			},
			inputAddress: ''
		};
	},
	methods: {
		password() {
			this.$router.push({ path: 'password' });
		},
		open() {
			this.$confirm('确定要保存吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let address
				if (this.form.deliveryType === '0'){
					address = '上海办公室员工（统一发送到上海办公室）'
				}
				if (this.form.deliveryType === '1'){
					address = '北京办公室员工（统一发送到北京办公室）'
				}
				if (this.form.deliveryType === '2'){
					address = this.inputAddress
				}
				const para = {
					id: this.form.id,
					phone: this.form.phone,
					deliveryType: this.form.deliveryType,
					deliveryAddress: address
				}
				saveAccount(para).then((response) => {
					if (response.data.success === true) {
						this.$message({ type: 'success', message: '保存成功!' })
						this.inputAddress = ''
						this.fetchData()
					} else {
						this.$message({ type: 'warning', message: '保存失败!' })
					}
				}).catch(() => {
						this.$message({ type: 'warning', message: '保存失败!' })
				})
			}).catch(() => {
				this.$message({
				type: 'info',
				message: '已取消保存'
				})
			})
		},
		fetchData () {
			const params = {
				id: this.$store.getters.id
			}
			accountInfo(params).then(response => {
				if (response.data.success === true) {
					this.form.id = response.data.data.id
					this.form.deliveryType = response.data.data.deliveryType.toString()
					this.form.phone = response.data.data.phone
					this.form.deliveryAddress = response.data.data.deliveryAddress
					this.form.loginName = response.data.data.loginName
					this.form.staffName = response.data.data.staffName
				} 
			}).catch(() => {
			})
		}
	},
	created() {
		this.fetchData()
	},
	components: {
		bar
	}
};
</script>

<style scoped="">
a {
	text-decoration: none;
}
.clearfix:after {
	content: '';
	display: block;
	clear: both;
}
.list-bar-ui {
	text-align: left;
}
.list-bar-ui li {
	list-style: none;
	color: white;
	font-weight: 200;
	margin-left: 20px;
	cursor: pointer;
	display: inline-block;
}
.top-bar {
	position: fixed;
	top: 0;
	bottom: auto;
	left: 0;
	right: auto;
	z-index: 80;
	width: 100%;
}
.top-color {
	height: 40px;
	background: #be0f34;
}
.top-color img {
	float: right;
	width: 209px;
	margin-top: 8px;
	padding-right: 300px;
}

.car-bar-box {
	cursor: pointer;
	width: 30px;
	height: 30px;
	background-image: url(../assets/img/cheo.png);
	background-size: 100%;
	background-repeat: no-repeat;
	position: absolute;
	top: 3px;
	right: 90px;
}
.address {
	font-size: 14px;
	width: 515px;
	height: 30px;
	background-color: #e5e5e5;
	margin-top: 20px;
	float: right;
	text-align: left;
	padding-left: 13px;
	line-height: 30px;
}
.information {
	font-size: 14px;
	width: 378px;
	height: 30px;
	background-color: #e5e5e5;
	margin-top: 20px;
	display: inline-block;
	float: left;
	text-align: left;
	padding-left: 13px;
	line-height: 30px;
}
</style>
